// Theme Colors
// Initially this will be blank. Later on when app is initialized we will assign bootstrap colors to this from CSS variables.
export const $themeColors = {}

// App Breakpoints
// Initially this will be blank. Later on when app is initialized we will assign bootstrap breakpoints to this object from CSS variables.
export const $themeBreakpoints = {}

// APP CONFIG
export const $themeConfig = {
  app: {
    // appName: 'Vuexy', // Will update name in navigation menu (Branding)
    appName: 'Cubus', // Will update name in navigation menu (Branding)
    // eslint-disable-next-line global-require
    // appLogoImage: require('@/assets/images/logo/logo.svg'), // Will update logo in navigation menu (Branding)
    appLogoImage: require('@/cubus/logo/cubus_logo_v5.svg'), // Will update logo in navigation menu (Branding)
  },
  layout: {
    isRTL: false,
    skin: 'light', // light, dark, bordered, semi-dark
    routerTransition: 'zoom-fade', // zoom-fade, slide-fade, fade-bottom, fade, zoom-out, none
    type: 'vertical', // vertical, horizontal
    contentWidth: 'full', // full, boxed
    menu: {
      hidden: false,
      isCollapsed: false,
    },
    navbar: {
      // ? For horizontal menu, navbar type will work for navMenu type
      // PROP-389: умолчание — `sticky`. Выбор темы не сохраняется (в localStorage живёт только
      // светлая/тёмная), поэтому значение отсюда человек и видит при каждом заходе.
      type: 'sticky', // static , sticky , floating, hidden
      backgroundColor: '', // BS color options [primary, success, etc]
    },
    footer: {
      type: 'static', // static, sticky, hidden
    },
    // PROP-398: кнопку настроек интерфейса (крутящаяся шестерёнка кастомайзера Vuexy) прячем.
    // Флаг гейтит `showCustomizer` во всех лэйаутах → `<app-customizer v-if="showCustomizer">`
    // не рендерится, и плавающая кнопка пропадает. Это демо-виджет шаблона, не наш функционал.
    customizer: false,
    enableScrollToTop: true,
  },
}
